"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("../style.css"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DndAddButton = function DndAddButton(props) {
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: 'btn btn-secondary ' + _style["default"].dndAddButton,
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null));
};
var _default = exports["default"] = DndAddButton;